module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABHNCSVQICAgIfAhkiAAAAOBJREFUKFOlk9ENgkAQRGcSP020BDtQK9AS7EA60GgDtoAVYCeUQAmUwIefJmuG3CGc3CWESzYkLG9nb3YhZhz2WTM7Angk6lUkrz4fwgJLkuVYATNTTgLtaWGneACgRO1ijM8AFAAakrmHKwBdO4m2105Az5uHB+3EYDPbANi5eE6CfVEzkzdD2MxOzu0mol6TzEJYJp0ByJBXwm15c3Hf3X3buotUvXI3jl4HGp+cVqiDYv6cAyOkoLGtgnvnev+3JCE8acN6sBS3iQ3bk5Qvv/UMfo4lgEVkVG+SH5/7Ar6kblv9SM1ZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_t3_on.png
// module id = cw7v
// module chunks = 85